export const TOTAL_SECONDS = 30

export const BRAND = 'SOLVENTUM'

export const BRAND_LOGO =
  'https://cdn.magicpatterns.com/uploads/jQTf4HGK9DcziiSEJLi9E6/solventum-logo-horz-clr-rev-cmyk.png'

export interface Clip {
  /** Optional real clinical footage. When present it plays instead of the frame sequence. */
  video?: string
  /** Frames played as a short 2–4s loop when no video source is supplied. */
  frames: string[]
  alt: string
}

/** Page 2 — the digitally planned attachment becoming the attachment that is actually bonded. */
export interface Morph {
  planned: string
  plannedLabel: string
  actual: string
  actualLabel: string
  alt: string
}

export const planToBond: Morph = {
  planned:
    'https://cdn.magicpatterns.com/patterns/generated-images/35615b10-1a55-45b5-9ccf-ef8e652226d5.jpg',
  plannedLabel: 'Digitally planned',
  actual:
    'https://cdn.magicpatterns.com/patterns/generated-images/95963534-8ca5-4f02-a1b8-5204797e31a8.jpg',
  actualLabel: 'Manually recreated',
  alt: 'A digitally planned attachment geometry alongside the composite attachment that is actually bonded to the tooth',
}

/** Page 5 — back to the planned movement and the force system behind it. */
export const forceClip: Clip = {
  frames: [
    'https://cdn.magicpatterns.com/patterns/generated-images/181c4a65-582b-4ef6-b64c-a0e431fbf152.jpg',
    'https://cdn.magicpatterns.com/patterns/generated-images/35615b10-1a55-45b5-9ccf-ef8e652226d5.jpg',
  ],
  alt: 'The planned tooth movement and force direction shown on the digital treatment plan',
}

export interface Deviation {
  name: string
  body: string
  image: string
}

/** The three places precision can be lost between plan and tooth. */
export const deviations: Deviation[] = [
  {
    name: 'Shape',
    body: 'The bonded geometry can differ from the planned geometry.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7cd350d7-6529-43e7-ae4f-aa5f5f174ad6.jpg',
  },
  {
    name: 'Position',
    body: 'Placement can differ from the planned location.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/38bbd729-2284-4a08-b03b-532417a7cbd3.jpg',
  },
  {
    name: 'Flash',
    body: 'Excess composite can affect attachment accuracy and force delivery.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e88037e1-33db-49c4-bbfb-4b9662b9da38.jpg',
  },
]

/** Q1 — TRACKING_PRIOR. Where diagnostic attention goes first. */
export const trackingPriorOptions = ['Patient', 'Plan', 'Attachment']



export const PRODUCT_NAME = 'Clarity Precision Grip Attachments'

/** The central device: the digital chain, and the step that breaks it. */
export const journey: string[] = [
  'Scan',
  'Plan',
  'Design',
  'Manufacture',
  'Attachment',
]

/** The same chain, completed. */
export const journeyResolved: string[] = [
  'Scan',
  'Plan',
  'Design',
  'Manufacture',
  'Precision Grip',
]

export const preloadedImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/94773a22-4fc2-4447-b0f7-dc062d3398d9.jpg'

export const preloadedImageAlt =
  'Precision Grip attachments, 3D printed and fully cured, pre-loaded in a transfer tray'

/** The new attachment journey. */
export const workflow: string[] = [
  'Digitally planned',
  '3D printed',
  'Fully cured',
  'Pre-loaded',
]

/** Page 6 — the complete exchange. */
export const exchange = [
  { label: '30 seconds', detail: 'invested' },
  { label: 'More precision', detail: 'preserved' },
  { label: '12 minutes', detail: 'back' },
]
